import { render, staticRenderFns } from "./manisDetailList.vue?vue&type=template&id=06b96c47&"
import script from "./manisDetailList.vue?vue&type=script&lang=js&"
export * from "./manisDetailList.vue?vue&type=script&lang=js&"
import style0 from "./manisDetailList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports